import { useEffect, useState } from 'react'
import {
	Alert, Box, Button, Dialog, DialogActions, DialogContent,
	DialogTitle, Divider, TextField, Typography
} from '@mui/material'

import SectorIndustrySelect from '../../../../components/SectorIndustrySelect'
import useInternalFetch from '../../../../api/apiInternal'
import config from '../../../../common/Config'

const ContextDialog = ({ open, context, onClose, onSaved }) => {
	const internalFetch                  = useInternalFetch()
	const [name, setName]                = useState('')
	const [description, setDescription] = useState('')
	const [sectors, setSectors]          = useState([])   // [{ market, sector, industry? }]
	const [isSaving, setIsSaving]        = useState(false)
	const [nameError, setNameError]      = useState(false)
	const [sectorsError, setSectorsError] = useState(false)
	const [saveError, setSaveError]      = useState(null)

	const isEdit = !!context

	useEffect(() => {
		if (!open) return
		setName(context?.name ?? '')
		setDescription(context?.description ?? '')
		setNameError(false)
		setSectorsError(false)
		setSaveError(null)
		setSectors(context?.parameterContextSectors ?? [])
	}, [open, context])

	const handleSave = () => {
		const nameInvalid    = !name.trim()
		const sectorsInvalid = sectors.length === 0
		if (nameInvalid)    setNameError(true)
		if (sectorsInvalid) setSectorsError(true)
		if (nameInvalid || sectorsInvalid) return
		setIsSaving(true)

		const body = {
			name        : name.trim(),
			description : description.trim() || null,
			sectors,
		}

		const url    = config.apiUrl + '/api/settings/contexts' + (isEdit ? `/${context.id}` : '')
		const method = isEdit ? 'PUT' : 'POST'

		internalFetch(url, {
			method,
			headers : { 'content-type': 'application/json; charset=utf-8' },
			body    : JSON.stringify(body),
		}).then(result => {
			setIsSaving(false)
			if (result?.message === 'CONTEXT_LIMIT_REACHED') {
				setNameError(false)
				setSaveError('Limite de 5 contextos atingido.')
				return
			}
			if (result?.id) onSaved(result)
		})
	}

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>{isEdit ? 'Editar contexto' : 'Novo contexto'}</DialogTitle>
			<DialogContent>
				{saveError && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setSaveError(null)}>{saveError}</Alert>}
				<TextField
					autoFocus
					fullWidth
					size="small"
					label="Nome"
					value={name}
					onChange={e => { setName(e.target.value); setNameError(false) }}
					error={nameError}
					helperText={nameError ? 'Nome obrigatório' : ''}
					sx={{ mt: 1, mb: 2 }}
				/>
				<TextField
					fullWidth
					size="small"
					multiline
					minRows={2}
					label="Lembrete (opcional)"
					placeholder="Por que criou este contexto?"
					value={description}
					onChange={e => setDescription(e.target.value)}
					sx={{ mb: 2 }}
				/>
				<Divider sx={{ mb: 2 }} />
				<Typography variant="caption" color={sectorsError ? 'error' : 'text.secondary'} fontWeight="bold" display="block" mb={1}>
					Setores / Indústrias *
				</Typography>
				<SectorIndustrySelect value={sectors} onChange={v => { setSectors(v); if (v.length > 0) setSectorsError(false) }} />
				{sectorsError && (
					<Typography variant="caption" color="error" display="block" mt={0.5}>
						Selecione ao menos um setor.
					</Typography>
				)}
			</DialogContent>
			<DialogActions>
				<Button size="small" onClick={onClose}>Cancelar</Button>
				<Button size="small" variant="contained" onClick={handleSave} disabled={isSaving}>
					Salvar
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default ContextDialog
